import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { useSystemConsole } from '../../../hooks/useSystemConsole';
import { BrowserTerminalCard } from './components/BrowserTerminalCard';
import { RecoveryConsoleCard } from './components/RecoveryConsoleCard';

const Access = () => {
  const { hostingId, canShow } = useSystemConsole();

  return (
    <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
      <Box flex={1}>
        <BrowserTerminalCard hostingId={hostingId} canShow={canShow} />
      </Box>

      <Box flex={1}>
        <RecoveryConsoleCard hostingId={hostingId} canShow={canShow} />
      </Box>
    </Stack>
  );
};

export default Access;
